// firebase
import { getFunctions, httpsCallable } from "firebase/functions";

// A ---------------------------------------------------------------------- M

const getFile = async (pathOrUrl, tagId = null) => {
  try {
    let arrayBuffer;

    // pathOrUrl è un URL, fetch diretto
    if (typeof pathOrUrl === "string" && (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://") || pathOrUrl.startsWith("blob:"))) {
      const resp = await fetch(pathOrUrl);
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const blob = await resp.blob();
      arrayBuffer = await blob.arrayBuffer();
    } else {
      // storagePath
      if (!tagId) throw new Error("tagId richiesto per recuperare URL firmato");

      const functions = getFunctions();
      const getSignedUrl = httpsCallable(functions, "getSignedDownloadUrl");

      const response = await getSignedUrl({ storagePath: pathOrUrl, tagId });
      const downloadURL = response.data.url;

      const resp = await fetch(downloadURL);
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const blob = await resp.blob();
      arrayBuffer = await blob.arrayBuffer();
    }

    return new Uint8Array(arrayBuffer);
  } catch (err) {
    console.error("Error in getFile:", err);
    return null;
  }
};

export default getFile;
